<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div class="p-4">
    <PrimeCard>
      <template #title>
        <h1 class="text-2xl m-0">
          {{ t("adminClassificationLauncher.title") }}
        </h1>
      </template>
      <template #content>
        <ClassificationPlanList
          :plans="existingPlans"
          :loading="loadingPlans"
          @select-plan="(plan) => emit('select-plan', plan)"
          @import-plan="loadExistingPlans"
        />
      </template>
    </PrimeCard>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";
import PrimeCard from "primevue/card";
import classificationService from "@/services/ClassificationService.js";
import ClassificationPlanList from "./ClassificationPlanList.vue";

const emit = defineEmits(["select-plan"]);

const toast = useToast();
const { t } = useI18n();

const loadingPlans = ref(true);
const existingPlans = ref([]);

const loadExistingPlans = () => {
  loadingPlans.value = true;
  classificationService
    .listPlanEntries()
    .then((plans) => {
      existingPlans.value = plans.sort((a, b) => a.name.localeCompare(b.name));
    })
    .catch((err) => {
      toast.add({
        severity: "error",
        summary: t("adminClassificationLauncher.toast.listError.summary"),
        detail: t("adminClassificationLauncher.toast.listError.detail"),
        life: 4000,
      });
      console.error(err);
    })
    .finally(() => {
      loadingPlans.value = false;
    });
};

onMounted(() => {
  loadExistingPlans();
});
</script>
